import React from 'react'
import About from "../Components/About/About"

export default function Aboutus() {
  return (
    <About />
  )
}
